import { createContext, useContext, useMemo, type ReactNode } from "react"

type FlowVersionsContextValue = {
  openVersions: (nodeId: number) => void
}

const FlowVersionsContext = createContext<FlowVersionsContextValue | null>(null)

export function FlowVersionsProvider({ children, onOpen }: { children: ReactNode; onOpen: (nodeId: number) => void }) {
  const value = useMemo(() => ({ openVersions: onOpen }), [onOpen])
  return <FlowVersionsContext.Provider value={value}>{children}</FlowVersionsContext.Provider>
}

export function useFlowVersions(): FlowVersionsContextValue | null {
  return useContext(FlowVersionsContext)
}
